import { gql } from '@apollo/client';
import { MEDIA_FRAGMENT } from './media.newsletter.graphql';

export const BLOCK_FRAGMENT = gql`
  fragment Block on Block {
    id
    title
    position
    surTitle
    content
    leadIn
    url
    body
    linkLabel
    rawMedia
    createdAt
    updatedAt
    media {
      ...Media
    }
    isAutoPromo
    blockType
  }
  ${MEDIA_FRAGMENT}
`;
